<template>
  <div class="flex flex-col items-center min-h-full p-4 bg-primary">
    <div class="w-full max-w-4xl m-auto">
      <div class="flex flex-col bg-white lg:flex-row rounded-xl overflow-hidden">
        <div class="w-full p-8 lg:w-3/5">
          <FormHeader heading="Review and Accept the Merchant Agreement"
            subHeading="To create your Elective account, please confirm the following" />
          <form @submit.prevent="submit">
            <div class="p-2 mt-4">
              <label for="termsAndConditions" class="flex items-start gap-2 text-sm font-light cursor-pointer">
                <input id="termsAndConditions" required type="checkbox" class="mt-1 cursor-pointer checkbox">
                <span>
                  I have reviewed and agree to Elective's
                  <a class="cursor-pointer btn-ghost text-secondary" target="_blank" :href="agreementLink">
                    Merchant Agreement
                  </a>
                </span>
              </label>
            </div>
            <div class="p-2">
              <label for="creditLossTerm" class="flex items-start gap-2 text-sm font-light cursor-pointer">
                <input id="creditLossTerm" required type="checkbox" class="mt-1 cursor-pointer checkbox">
                <span>
                  I agree and understand that a transaction's payout will be refunded
                  if the customer fails to make their first and second payments.*
                </span>
              </label>
            </div>
            <button class="w-full my-2 btn btn-secondary">
              Accept Agreement
            </button>
          </form>
          <div v-if="error">
            <div class="text-center text-error">
              {{ error }}
            </div>
          </div>
        </div>
        <div class="hidden lg:block lg:w-2/5">
          <ImageWithQuote quote="Elective was the best decision we made this year to supercharge sales."
            name="Teri Iejoma" designation="Founder of Trade & Travel - #1 Teachable Business" imageName="teri.svg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Pages } from '@/router';
import FormHeader from '@/components/form_header.vue';
import ImageWithQuote from '@/components/image_with_quote/index.vue';
import { addPricingAgreement } from './api/add_pricing_agreement';
import { getPricingAgreement } from './api/get_pricing_agreement';

const error = ref('');
const agreementLink = ref('');
const feeScheduleLink = ref('');

const projectId = useRoute().params.projectId as string;
const router = useRouter();

onMounted(async () => {
  const data = await getPricingAgreement(projectId);
  agreementLink.value = data.agreement.link;
  feeScheduleLink.value = data.feeSchedule.link;
});

async function submit() {
  try {
    await addPricingAgreement(projectId);

    router.push({ name: Pages.onboardingProgress });
  } catch (err: any) {
    error.value = err.response?.data?.message || 'Something went wrong';
  }
}

</script>
